module.exports = __webpack_public_path__ + "static/media/ecgCheck.5cb6878b.mp3";